var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStraightRuler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 6.25,
    width: 2.5,
    height: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 18.25,
    width: 2.5,
    height: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.375,
    y: 17.875,
    width: 4.75,
    height: 0.75,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.375,
    y: 5.375,
    width: 4.75,
    height: 0.75,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.25,
    y: 9.25,
    width: 1.5,
    height: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 12.25,
    width: 2.5,
    height: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.25,
    y: 15.25,
    width: 1.5,
    height: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.75,
    y1: 6,
    x2: 7.75,
    y2: 19,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraightRuler);
export default __webpack_public_path__ + "static/media/straight-ruler.c8f3e809.svg";
export { ForwardRef as ReactComponent };